/**
 * AI routes and API-key providers (AI settings).
 *
 * Work runs through one of two routes, chosen each time it is sent:
 *  - "machine": a paired computer, using whatever AI account and model that
 *    computer has set as its default. CompBox does not pick the model.
 *  - "api_key": CompBox's cloud runner, using the person's API key — their own,
 *    or the company key an org admin set, which they inherit.
 */
export const aiRouteValues = ["machine", "api_key"];
export const aiProviderValues = ["anthropic", "openai", "xai", "openrouter"];
export const AI_PROVIDERS = {
    anthropic: {
        id: "anthropic",
        name: "Anthropic (Claude)",
        keyPageUrl: "https://console.anthropic.com/settings/keys",
        limitsPageUrl: "https://console.anthropic.com/settings/limits",
        keyPrefix: "sk-ant-",
        steps: [
            "Sign in to the Anthropic Console and add a payment method or credits under Billing.",
            "Open API keys and choose Create key. Name it after this project, for example \"CompBox – My App\".",
            "Copy the key. Anthropic shows it only once.",
            "Optional: set a monthly spend limit under Limits.",
        ],
        reportsBalance: false,
    },
    openai: {
        id: "openai",
        name: "OpenAI",
        keyPageUrl: "https://platform.openai.com/api-keys",
        limitsPageUrl: "https://platform.openai.com/settings/organization/limits",
        keyPrefix: "sk-",
        steps: [
            "Sign in to the OpenAI Platform and add credits under Billing.",
            "Open API keys and choose Create new secret key. Name it after this project.",
            "Copy the key. OpenAI shows it only once.",
            "Optional: set a monthly budget under Limits.",
        ],
        reportsBalance: false,
    },
    xai: {
        id: "xai",
        name: "xAI (Grok)",
        keyPageUrl: "https://console.x.ai",
        limitsPageUrl: "https://console.x.ai",
        keyPrefix: "xai-",
        steps: [
            "Sign in to the xAI Console and add credits under Billing.",
            "Open API Keys and create a key. Name it after this project.",
            "Copy the key. xAI shows it only once.",
            "Optional: set a spending limit in the console.",
        ],
        reportsBalance: false,
    },
    openrouter: {
        id: "openrouter",
        name: "OpenRouter",
        keyPageUrl: "https://openrouter.ai/settings/keys",
        limitsPageUrl: "https://openrouter.ai/settings/credits",
        keyPrefix: "sk-or-",
        note: "One key for models from many providers, including free models with daily limits.",
        steps: [
            "Sign in to OpenRouter. Free models work without credits; add credits under Credits for paid models and higher limits.",
            "Open Keys and choose Create key. Name it after yourself or your company, and optionally set a credit limit on the key.",
            "Copy the key. OpenRouter shows it only once.",
        ],
        reportsBalance: true,
    },
};
//# sourceMappingURL=ai-providers.js.map